<template>
    <div class="text-center h-100 d-flex flex-column align-items-center">
        <a :href="productUrl" class="product-image w-100">
            <div class="d-flex align-items-center justify-content-center" style="min-height: 260px; min-width: 0">
                <img :src="baseImage" :class="{ 'image-placeholder': ! hasBaseImage }" class="img-fluid" style="max-height: 260px; max-width: 260px; min-width: 0" alt="product image">
            </div>
        </a>
        <a :href="productUrl" class="d-block">
            <h4 class="mt-3 mb-4">{{ product.name }}</h4>
        </a>
        <a :href="productUrl" class="btn btn-secondary btn-custom-padding text-uppercase mt-auto" style="flex-basis: 0">View</a>
    </div>

</template>

<script>
    import ProductRating from './ProductRating.vue';
    import ProductCardMixin from '../mixins/ProductCardMixin';

    export default {
        components: { ProductRating },

        mixins: [
            ProductCardMixin,
        ],

        props: ['product'],
    };
</script>
